module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoaded) ? _c('div', _vm._l((_vm.model), function(campo) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-lg-2 control-label"
    }, [_vm._v(_vm._s(campo.nome))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (campo.valor),
        expression: "campo.valor"
      }],
      staticClass: "form-control w-auto",
      attrs: {
        "type": "text",
        "required": campo.obrigatorio
      },
      domProps: {
        "value": (campo.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(campo, "valor", $event.target.value)
        }
      }
    })])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fab74bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/TipoBemCampos.vue
// module id = 730
// module chunks = 2